'use client';

import { type FC, useEffect } from 'react';
import { usePathname } from 'next/navigation';

import { useModalManager } from '@shared/lib';
import { BaseAlertDialog, BaseDrawer, BaseModal } from '@shared/ui-kit';

const ModalRenderer: FC = () => {
  const pathname = usePathname();

  const { isOpen, config, close } = useModalManager();

  // Закрыть модальное окно при смене маршрута
  useEffect(() => {
    if (isOpen) close();
  }, [pathname]);

  if (!config) return null;

  switch (config.variant) {
    case 'modal':
      return (
        <BaseModal
          config={config}
          isOpen={isOpen}
          onClose={close}
        />
      );

    case 'alertDialog':
      return (
        <BaseAlertDialog
          config={config}
          isOpen={isOpen}
          onClose={close}
        />
      );

    case 'drawer':
      return (
        <BaseDrawer
          config={config}
          isOpen={isOpen}
          onClose={close}
        />
      );

    default:
      return null;
  }
};

export default ModalRenderer;
